import stls from '@f_qwep/styles/component/orders/Orders.module.sass';
import { Tooltip } from '@mui/material';

export function CellPrice({ info }: any) {
    return <p className={stls.cellPrice}>{(+info.row.original.price).toLocaleString()} ₽</p>;
}
